import { render, staticRenderFns } from "./DocumentDetails.vue?vue&type=template&id=02300106&"
import script from "./DocumentDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02300106')) {
      api.createRecord('02300106', component.options)
    } else {
      api.reload('02300106', component.options)
    }
    module.hot.accept("./DocumentDetails.vue?vue&type=template&id=02300106&", function () {
      api.rerender('02300106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/EmployeeManagement/EmployeeDetails/DocumentDetails.vue"
export default component.exports